import React, { useEffect } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import { Link } from "react-router-dom";
import Brands1 from "../brands/Brands1";
import { FaArrowRight } from "react-icons/fa";
import "aos/dist/aos.css";
import AOS from "aos";


const servicesData = [
  {
    title: "AI Programs",
    icon: "/images/services/dmcicon1.png",
    description:
    "Master AI fundamentals, machine learning, and Python programming through IIT Bombay's Spoken Tutorial – empowering learners with future-ready AI skills.",
    animation: "fadeInDown",
  },
  {
    title: "Digital Marketing Course",
    icon: "/images/services/dmcicon2.png",
    description:
      "Learn SEO, SEM, social media, and analytics via hybrid modules and FOSS tools, guided by IIT Bombay-certified digital marketing content.",
    animation: "fadeInDown",
  },
  {
    title: "Analytics Programs",
    icon: "/images/services/dmcicon3.png",
    description:
      "Build expertise in data visualization, Excel, R, and Python analytics through self-paced, language-friendly tutorials certified by IIT Bombay.",
    animation: "slideInRight",
  },
];

const Iidts = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      <BreadcrumbsHeader 
        title="Indian Institute of Digital Transformations" 
        backgroundImage="/images/iidt-banner.png" 
      />

 <section className="section-services">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="b-mod-heading text-center">
              <p className="first-heading font-secondary wow fadeInDown" >
              Educating, Empowering & Enlightening Technically Digitally</p>
              <h2 className="heading-line line-right customColor customPseudoElBg wow fadeIn" >
                <strong>Indian Institute of Digital Transformations</strong>
              </h2>
              <p className="logomain1">
                <img src="/images/IIDT.webp" alt="Indian Institute of Digital Transformations" />
              </p>
              <p className="second-heading font-additional">
              Indian Institute of Digital Transformations (IIDTs)—a pioneering platform designed to empower students, professionals, and business owners with cutting-edge knowledge and skills in digital marketing, AI, cyber & cloud. As a sister concern of ISOLS Group, a leading name in technology, digital analytics, and AI solutions, IIDTs brings unmatched industry expertise and a vision to revolutionize the learning experience in the digital marketing domain.
              <br /><br />
             At IIDTs, we believe in a “Less Ordinary” approach—an ecosystem where learning is practical, personalized, and profoundly impactful. Our certified training programs are meticulously curated to cater to the diverse needs of students from all disciplines, working professionals aiming for career growth, and business owners striving to navigate the digital revolution. Every course is infused with real-world applications, ensuring that our learners graduate not just with knowledge, but with confidence and competence to lead in the ever-evolving digital landscape.
             </p>  </div>
          </div>
        </div>

        <div className="b-services-holder">
          <div className="row">
            {servicesData.map((service, index) => (
              <div className={`col-xs-6 col-sm-4 wow ${service.animation}`}  key={index}>
                <div className="b-services-item">
                  <div className="services-icon">
                    <img src={service.icon} alt={service.alt} />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      {service.title}
                    </h6>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <section className="section-servicess">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="b-mod-heading1 text-center">
              <h3
                className="heading-line1 line-right customColor customPseudoElBg wow fadeIn"
                style={{ visibility: "visible", animationName: "fadeIn" }}
              >
                <strong>Partner with IIT Bombay</strong>
              </h3>
            </div>

            <div className="row">
              <div className="col-xs-6 col-sm-6 col-xs-offset-3">
                <img
                  src="/images/loa.jpg"
                  alt="iit bombay"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
   
   <Brands1 />
    </div>
  );
};

export default Iidts;
